
import React from 'react';
import { WhatsAppIcon } from './IconComponents';

interface WhatsAppButtonProps {
  isVisible: boolean;
}

export const WhatsAppButton: React.FC<WhatsAppButtonProps> = ({ isVisible }) => {
  const phoneNumber = '34644907194';
  const message = 'Atencion Comercial';
  const encodedMessage = encodeURIComponent(message);
  
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

  return (
    <div 
      className={`fixed bottom-6 right-6 z-50 w-40 h-40 flex items-center justify-center group transition-opacity duration-300 ${isVisible ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
    >
      <svg 
        className="absolute w-full h-full animate-spin-slow" 
        viewBox="0 0 160 160"
        aria-hidden="true"
      >
        <defs>
          <path id="curve"
            fill="transparent"
            d="M 80,18 a 62,62 0 1,1 0,124 a 62,62 0 1,1 0,-124"
          />
        </defs>
        <text className="text-[13px] font-bold fill-current text-amber-400 tracking-wider uppercase">
          <textPath href="#curve">
            Atencion Comercial por Whatsapp Business •&nbsp;
          </textPath>
        </text>
      </svg>
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="relative p-4 bg-green-600 text-white rounded-full shadow-lg group-hover:shadow-2xl transition-all duration-300 transform group-hover:scale-110 animate-pulse-green"
        aria-label="Contactar por WhatsApp"
      >
        <WhatsAppIcon className="w-8 h-8" />
      </a>
    </div>
  );
};
